<template>
    <div class="staff">
<!--        商品管理-->
        <main class="content">
            <el-card>
                <el-form ref="productForm" :model="productForm" :rules="rules" label-width="120px">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="SKU" prop="sku" size="mini">
                                <template slot="label">
                                    <span>
                                        SKU
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                系统自动生成，不可编辑
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.sku" disabled clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="商品名称" prop="name" size="mini">
                                <template slot="label">
                                    <span>
                                        商品名称
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                显示在页面上的商品名称，也会用于搜索，建议包含品牌、名称及主要参数信息
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.name" placeholder="请输入商品名称" maxlength="200" show-word-limit clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="合同名称" prop="shortName" size="mini">
                                <template slot="label">
                                    <span>
                                        合同名称
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                与天创合同中约定的名称，当合同中的商品名称与页面显示的商品名称不同时，此处填写合同中的商品名称，一致时此处可不填
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.shortName" placeholder="请输入合同商品名称" maxlength="100" show-word-limit clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品品牌" prop="brandId" size="mini">
                                <template slot="label">
                                    <span>
                                        商品品牌
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品品牌，已有品牌请从下拉列表中选择，没有的品牌系统会自动添加
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-select style="width:100%"
                                    v-model="productForm.brandId"
                                    filterable
                                    remote
                                    reserve-keyword
                                    clearable
                                    placeholder="请输入品牌名称"
                                    allow-create
                                    :remote-method="loadBrand"
                                    :loading="brandLoading">
                                        <el-option
                                        v-for="item in brands"
                                        :key="item.id"
                                        :label="item.nameCh + ' (' + item.nameEn + ')'"
                                        :value="item.id"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="商品型号" size="mini" prop="model">
                                <template slot="label">
                                    <span>
                                        商品型号
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品型号
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.model" placeholder="请输入商品型号" maxlength="100" show-word-limit clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="商品分类" prop="categoryIds" size="mini"><template slot="label">
                                <template slot="label"></template>
                                    <span>
                                        商品分类
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品分类，用户可通过商品分类菜单筛选对应的商品
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-cascader v-model="productForm.categoryIds" :props="category" placeholder="请选择分类" style="width:100%" @change="changeCategory"></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="更多分类" size="mini">
                                <template slot="label">
                                    <span>
                                        更多分类
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                一个商品最多可设置10个关联分类，用户通过分类菜单筛选时，关联分类也可以筛选出商品
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-button type="primary" @click="showMoreCategoryDialog">关联更多分类</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="封面图" prop="thumbnail" size="mini">
                                <template slot="label">
                                    <span>
                                        封面图
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                首页及列表中显示的商品图片。单张不超过2MB
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-upload
                                    class="avatar-uploader"
                                    ref="upload"
                                    action="/api/admin/uploadImage"
                                    name="file"
                                    list-type="picture-card"
                                    :show-file-list="false"
                                    :file-list="fileList"
                                    :on-exceed="onExceed"
                                    :before-upload="beforeUpload"
                                    :on-preview="handlePreview"
                                    :on-success="handleSuccess"
                                    :on-remove="handleRemove">
                                    <img v-if="productForm.thumbnail" width="100%" :src="productForm.thumbnail.startsWith('http') ? productForm.thumbnail : '/api'+productForm.thumbnail"  class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="16">
                            <el-form-item label="图片" prop="images" size="mini">
                                <template slot="label">
                                    <span>
                                        图片
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                详情页中，商品描述左侧图片，最多3张。单张不超过2MB
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-upload
                                    class="picture-card"
                                    ref="uploadImages"
                                    action="/api/admin/uploadImage"
                                    name="file"
                                    list-type="picture-card"
                                    :limit="3"
                                    :file-list="images"
                                    :on-exceed="onImageExceed"
                                    :before-upload="beforeImageUpload"
                                    :on-success="handleImageSuccess"
                                    :on-remove="handleImageRemove">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="货期" prop="delivery" size="mini">
                                <template slot="label">
                                    <span>
                                        货期
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                -1：需询货期；0：现货；其他大于0的整数表示实际货期天数
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.delivery" placeholder="请输入货期" clearable>
                                    <template slot="append">天</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="单位" prop="unit" size="mini">
                                <template slot="label">
                                    <span>
                                        单位
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品售卖单位
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.unit" placeholder="请输入商品单位" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="库存" prop="stock" size="mini">
                                <template slot="label">
                                    <span>
                                        库存
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品库存，商品下单后，平台会减少库存，但无法获取供应商实际库存，需要通过接口或页面定期维护库存数量
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.stock" placeholder="请输入商品单位" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="商品面价" prop="supplierOfficialPrice" size="mini">
                                <template slot="label">
                                    <span>
                                        商品面价
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品面价/官方报价
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.supplierOfficialPrice" placeholder="请输入商品面价" clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="未税采购" prop="supplierUntaxedPrice" size="mini">
                                <template slot="label">
                                    <span>
                                        未税采购
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                未税采购单价
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.supplierUntaxedPrice" placeholder="请输入未税采购单价" disabled clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="含税采购" prop="supplierPrice" size="mini">
                                <template slot="label">
                                    <span>
                                        含税采购
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                含税采购单价
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.supplierPrice" placeholder="请输入含税采购单价" disabled clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="未税销售" prop="untaxedPrice" size="mini">
                                <template slot="label">
                                    <span>
                                        未税销售
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                未税销售单价
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.untaxedPrice" placeholder="请输入未税销售单价" clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="含税销售" prop="price" size="mini">
                                <template slot="label">
                                    <span>
                                        含税销售
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                含税销售单价
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.price" placeholder="请输入含税销售单价" clearable>
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="锁定销售价" prop="price" size="mini">
                                <template slot="label">
                                    <span>
                                        锁定销售价
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                锁定含税和未税的销售价格
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-checkbox size="small" v-model="productForm.lockPrice"></el-checkbox>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="最小起售量" prop="moq" size="mini">
                                <template slot="label">
                                    <span>
                                        最小起售量
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品售卖单位的最小起订量
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.moq" placeholder="请输入商品最小起订量" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="供应商" prop="supplier" size="mini">
                                <template slot="label">
                                    <span>
                                        供应商
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品的供应商
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <!-- <el-select style="width:100%"
                                    v-model="productForm.supplier"
                                    filterable
                                    remote
                                    clearable
                                    reserve-keyword
                                    placeholder="请输入供应商名称"
                                    :remote-method="loadSupplier"
                                    :loading="supplierLoading">
                                        <el-option
                                        v-for="supplier in suppliers"
                                        :key="supplier.key"
                                        :label="supplier.value"
                                        :value="supplier.key"
                                        ></el-option>
                                </el-select> -->
                                <el-input v-model="productForm.supplier" placeholder="请选择供应商" disabled clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="供应商SKU" prop="supplierSku" size="mini">
                                <template slot="label">
                                    <span>
                                        供应商SKU
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                供应商自己定义商品编码，请确保同一个供应商下的商品编码是唯一的
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.supplierSku" placeholder="请输入供应商SKU" disabled clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="商品标签" prop="label" size="mini">
                                <template slot="label">
                                    <span>
                                        商品标签
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品标签，自动做为查询条件，多个标签间以逗号分割(,)
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input v-model="productForm.label" placeholder="请输入商品标签" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-divider content-position="left">
                        <span>
                            商品属性
                            <el-tooltip placement="right">
                                <i class="el-icon-question"></i>
                                <div slot="content">
                                    自定义商品属性，如：颜色：蓝色、长度：15厘米
                                </div>
                            </el-tooltip>
                        </span>
                    </el-divider>
                    <el-row v-for="one in infos" :key="one.key" class="groupInput">
                        <el-form-item size="mini">
                            <el-input v-model="one.value" placeholder="请输入商品属性值" clearable v-if="!one.values || one.values.length === 0">
                                <el-input slot="prepend" v-model="one.name" placeholder="请输入商品属性名" style="width: 150px" clearable></el-input>
                                <el-button slot="append" icon="el-icon-close" @click="() => delInfo(one.key)"></el-button>
                            </el-input>
                            <div style="display: flex;" v-if="one.values && one.values.length > 0 && one.allowNonOption">
                                <el-input v-model="one.name" placeholder="请输入商品属性名" style="width: 150px" clearable></el-input>
                                <el-select
                                    style="flex-grow: 1;"
                                    v-model="one.value"
                                    placeholder="请输入商品属性值"
                                    clearable
                                    allow-create
                                >
                                    <el-option
                                        v-for="item in one.values"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.value"
                                        ></el-option>
                                </el-select>
                                <el-button icon="el-icon-close" @click="() => delInfo(one.key)"></el-button>
                            </div>
                            <div style="display: flex;" v-if="one.values && one.values.length > 0 && !one.allowNonOption">
                                <el-input v-model="one.name" placeholder="请输入商品属性名" style="width: 150px" clearable></el-input>
                                <el-select
                                    style="flex-grow: 1;"
                                    v-model="one.value"
                                    placeholder="请输入商品属性值"
                                    clearable
                                >
                                    <el-option
                                        v-for="item in one.values"
                                        :key="item.value"
                                        :label="item.value"
                                        :value="item.value"
                                        ></el-option>
                                </el-select>
                                <el-button icon="el-icon-close" @click="() => delInfo(one.key)"></el-button>
                            </div>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item size="mini">
                            <el-button type="primary" @click="addInfo">添加属性</el-button>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="图文介绍" size="mini">
                        <template slot="label">
                                    <span>
                                        图文介绍
                                        <el-tooltip placement="right">
                                            <i class="el-icon-question"></i>
                                            <div slot="content">
                                                商品图文介绍
                                            </div>
                                        </el-tooltip>
                                    </span>
                                </template>
                        <quill-editor v-model="productForm.description" :options="editorOption"></quill-editor>
                    </el-form-item>
                </el-form>
                <div style="text-align: center;" size="mini">
                    <el-button type="primary" @click="onSubmitProduct" size="mini" :loading="loading">保 存</el-button>
                </div>
            </el-card>
        </main>
        <el-dialog title="关联更多分类" :visible.sync="relationCategoryDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="productForm" label-width="80px">
                <el-form-item v-for="(categoryId, index) in relationCategoryIds" :key="index" :label="'分类'+(index+1)" size="mini">
                    <el-cascader v-model="relationCategoryIds[index]" :props="category" placeholder="请选择分类" style="width:100%" clearable></el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="relationCategoryDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onSubmitRelationCategory" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Quill from 'vue-quill-editor'
import {quillRedefine} from 'vue-quill-editor-upload'//引入图片上传
export default {
    data() {
        let _this = this;
        return {
            modifyTemplate: false,
            loadedProduct: false,
            category: {
                label: "name",
                value: "id",
                lazy: true,
                checkStrictly: true,
                lazyLoad (node, resolve) {
                    if(_this.loadedProduct) {
                        _this.loadCategory(node, resolve);
                    } else {
                        let interval = setInterval(() => {
                            if(_this.loadedProduct) {
                                clearInterval(interval);
                                _this.loadCategory(node, resolve);
                            }
                        }, 500);
                    }
                }
            },
            relationCategory: {
                label: "name",
                value: "id",
                lazy: true,
                multiple: true,
                checkStrictly: true,
                lazyLoad (node, resolve) {
                    if(_this.loadedProduct) {
                        _this.loadCategory(node, resolve);
                    } else {
                        let interval = setInterval(() => {
                            if(_this.loadedProduct) {
                                clearInterval(interval);
                                _this.loadCategory(node, resolve);
                            }
                        }, 500);
                    }
                }
            },
            loading: false,
            productData: [],
            productTotal: 0,
            productPageSize: 10,
            productCurrentPage: 1,
            brandLoading: false,
            brands: [],
            templateLoading: false,
            templates: [],
            fileList: [],
            editorOption:{},
            relationCategoryIds:[],
            images: [],
            productForm: {
                id: "",
                name: "",
                sku: "",
                supplierSku: "",
                model: "",
                setId: "",
                brandId: "",
                templateId: "",
                itemNumber: "",
                categoryId: "",
                price: "",
                delivery: "",
                unit: "",
                stock: "",
                supplier: "",
                supplierOfficialPrice: "",
                supplierUntaxedPrice: "",
                supplierPrice: "",
                untaxedPrice: "",
                categoryIds: [],
                relationCategoryIds: [],
                properties: [],
                images: [],
                thumbnail: "",
                description: "",
                info: {},
                status: "1",
                recommend: "",
                calcPrice: "",
                calcUntaxedPrice: "",
                lockPrice: false,
                label: '',
            },
            infos: [],
            editDialogVisible: false,
            valueLoading: false,
            dialogPreviewVisible: false,
            relationCategoryDialogVisible: false,
            dialogImageUrl: "",
            supplierLoading: false,
            suppliers: [],
            imageList: [],
            rules: {
                supplier: [
                    { required: true, message: '请选择供应商', trigger: 'blur' }
                ],
                supplierSku: [
                    { required: true, message: '请填写供应商SKU', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请填写商品名称', trigger: 'blur' }
                ],
                brandId: [
                    { required: true, message: '请填写商品品牌', trigger: 'blur' }
                ],
                categoryIds: [
                    { required: true, message: '请选择商品分类', trigger: 'blur' }
                ],
                templateId: [
                    { required: true, message: '请选择属性模板', trigger: 'blur' }
                ],
                thumbnail: [
                    { required: true, message: '请上传封面图', trigger: 'blur' }
                ],
                images: [
                    { validator: (rule, value, callback) => {
                        if(this.images.length===0) {
                            callback('请上传图片');
                        } else {
                            callback();
                        }
                    }, trigger: 'blur' }
                ],
                // sku: [
                //     { required: true, message: '请输入商品编号', trigger: 'blur' }
                // ],
                model: [
                    { required: true, message: '请输入商品型号', trigger: 'blur' }
                ],
                delivery: [
                    { required: true, message: '请输入货期', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /^-?\d*$/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效数字');
                        }
                    }, trigger: 'blur' }
                ],
                unit: [
                    { required: true, message: '请输入商品单位', trigger: 'blur' }
                ],
                stock: [
                    { required: true, message: '请输入商品库存', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /^-?\d*$/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效数字');
                        }
                    }, trigger: 'blur' }
                ],
                supplierOfficialPrice: [
                    { required: true, message: '请输入商品面价', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效价格');
                        }
                    }, trigger: 'blur' }
                ],
                supplierUntaxedPrice: [
                    { required: true, message: '请输入未税单价', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /(^[1-9]\d*(\.\d{1,6})?$)|(^0(\.\d{1,6})?$)/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效价格');
                        }
                    }, trigger: 'blur' }
                ],
                supplierPrice: [
                    { required: true, message: '请输入含税单价', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /(^[1-9]\d*(\.\d{1,6})?$)|(^0(\.\d{1,6})?$)/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效价格');
                        }
                    }, trigger: 'blur' }
                ],
                untaxedPrice: [
                    { required: true, message: '请输入未税单价', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /(^[1-9]\d*(\.\d{1,6})?$)|(^0(\.\d{1,6})?$)/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效价格');
                        }
                    }, trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请输入含税单价', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        const reg = /(^[1-9]\d*(\.\d{1,6})?$)|(^0(\.\d{1,6})?$)/;
                        if(reg.test(value)) {
                            callback();
                        } else {
                            callback('请输入有效价格');
                        }
                    }, trigger: 'blur' }
                ],
            },
        }
    },
    props: ["productSetId"],
    methods: {
        init() {
            // this.fetchRegion();
            const { id } = this.$route.query;
            if(id) {
                this.query(id);
            } else {
                this.loadedProduct = true;
            }
            // if(this.productSetId == undefined || this.productSetId == "") {
            //     this.loadedProduct = true;
            // } else {
            //     this.loadedProduct = true;
            // }
        },
        query(id) {
            this.pageLoading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _this = this;
            this.$axios.get("/admin/product/"+id)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.productForm = resp.data;
                    if(_this.productForm.relationCategoryIds) {
                        _this.productForm.relationCategoryIds = _this.productForm.relationCategoryIds.slice(0, _this.productForm.relationCategoryIds.length-1);
                    }
                    if(resp.data.images) {
                        _this.images = resp.data.images.map(it => {
                            let path = it["url"].split("/");
                            return {
                                name: path[path.length -1],
                                url: it['url'].startsWith('http') ? it['url'] : '/api'+it['url'],
                            }
                        });
                    }
                    if(resp.data.info) {
                        _this.infos = Object.keys(resp.data.info).map(key => {
                            return {
                                key: _this.getUuid(),
                                name: key,
                                value: resp.data.info[key],
                            }
                        });
                    }
                    _this.loadedProduct = true;
                    _this.$axios.post("/admin/product/brand/list", {
                            id: _this.productForm.brandId,
                        })
                        .then(function(response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.brands = resp.data;
                                // _this.$axios.get("/admin/supplier/listOptions/"+_this.productForm.supplier)
                                // .then(function(response) {
                                //     let resp = response.data;
                                //     if (resp.header.status == 0) {
                                //         _this.suppliers = resp.data;
                                //     }
                                // }).finally(() => {
                                //     _this.pageLoading.close();
                                //     _this.pageLoading = undefined;
                                // });
                            }
                        }).finally(() => {
                            _this.pageLoading.close();
                            _this.pageLoading = undefined;
                        });
                }
            }).finally(() => {
            });
        },
        changeCategory(v) {
            const { id } = this.$route.query;
            if(!id && v.length === 3 && this.infos.length === 0) {
              this.$axios.get(`/admin/product/category/property/${v[2]}`)
              .then((response) => {
                let resp = response.data;
                if (resp.header.status === 0) {
                    if(resp.data && resp.data.length > 0) {
                        this.infos = resp.data.filter(it => !it.isBrand)
                        .map(it => ({
                            ...it,
                            key: it.id,
                            name: it.name,
                            value: '',
                        }))
                    }
                }
              });
            }
        },
        loadBrand(query) {
            if(query=="") return;
            this.brandLoading = true;
            let _this = this;
            this.$axios.post("/admin/product/brand/contain", {
                nameCh: query,
            }).then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.brands = resp.data;
                }
            }).finally(() => {
                _this.brandLoading = false;
            });
        },
        loadCategory(node, resolve) {
            let _this = this;
            let params = {};
            if(node.root) {
                params["fid"] = "root";
            } else {
                params["fid"] = node.value;
            }
            _this.$axios.post("/admin/product/category/list", params)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    resolve(resp.data);
                }
            }).catch(function () {
            });
        },
        loadSupplier(query) {
            if(query=="") return;
            this.supplierLoading = true;
            let _this = this;
            this.$axios.get("/admin/supplier/listOptions/"+query)
            .then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.suppliers = resp.data;
                }
            }).finally(() => {
                _this.supplierLoading = false;
            });
        },
        changeTemplate(value) {
            let _this = this;
            this.$axios
            .get("/admin/property/template/listProperty/" + value)
            .then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.productForm.properties = resp.data;
                }
            })
            .catch(function() {});
        },
        //文件上传成功的钩子函数
        handleSuccess(res, file) {
            if (file.response.data.success) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                this.productForm.thumbnail = file.response.data.message; //将返回的文件储存路径赋值picture字段
            } else {
                this.$message({
                    type: 'info',
                    message: '图片上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleRemove() {
            this.productForm.thumbnail = "";
            this.$message({
                type: 'info',
                message: '已删除原有图片',
                duration: 6000
            });
        },
        //点击列表中已上传的文件事的钩子函数
        handlePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onExceed() {
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
        },
        //文件上传成功的钩子函数
        handleImageSuccess(res, file) {
            if (file.response.data.success) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                this.images.push({name:file.name, url:file.response.data.message.startsWith("http") ? file.response.data.message : "/api"+file.response.data.message});
            } else {
                this.$message({
                    type: 'info',
                    message: '图片上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleImageRemove(file) {
            let bDelete = false;
            for(var i=0; i<this.images.length; i++) {
                if(this.images[i].name == file.name) {
                    this.images.splice(i, 1);
                    bDelete =true;
                }
            }
            if(bDelete) {
                this.$message({
                    type: 'info',
                    message: '图片删除成功',
                    duration: 6000
                });
            }
        },
        //点击列表中已上传的文件事的钩子函数
        handleImagePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onImageExceed() {
            this.$message({
                type: 'info',
                message: '最多只能上传三张图片',
                duration: 6000
            });
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeImageUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 2;
            var distinct = true;
            for(var i=0; i<this.images.length; i++) {
                if(this.images[i].name == file.name) {
                    distinct = false;
                    break;
                }
            }
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            if(!distinct) {
                this.$message.error('不能上传相同的图片');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt2M && distinct;
        },
        goBack() {
            this.$router.go(-1);
        },
        priceFormatter(row, column, cellValue) {
            return "￥" + cellValue + "元";
        },
        showMoreCategoryDialog() {
            this.relationCategoryIds = [];
            for(let i=0; i<this.productForm.relationCategoryIds.length; i++) {
                this.relationCategoryIds.push(this.productForm.relationCategoryIds[i]);
            }
            var len = this.relationCategoryIds.length;
            for(let i=10; i>len; i--) {
                this.relationCategoryIds.push([]);
            }
            this.relationCategoryDialogVisible = true;
        },
        onSubmitProduct() {
            let that = this;
            this.$refs['productForm'].validate((ok) => {
                if(!ok) {
                    return;
                }
                that.productForm.images = that.images.map(it => it.url);

                that.productForm.info = {};
                that.infos.forEach(it => {
                    that.productForm.info[it['name']] = it['value'];
                });
                that.loading = true;
                that.$axios.post("/admin/product/saveOne", that.productForm)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.productForm.id = resp.data.id;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).finally(() => {
                    that.loading = false;
                });
            });
        },
        initQuill() {
            let fonts = ['SimSun', 'SimHei'];
            Quill.Quill.imports['formats/font'].whitelist=fonts;
            Quill.Quill.register(Quill.Quill.imports['formats/font']);

            const toolbarOptions = [
                ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
                [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
                [{ align: [] }], // 对齐方式-----[{ align: [] }]
                // [{ size: fontSizeStyle.whitelist }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
                [{ font: fonts }], // 字体种类-----[{ font: [] }]
                [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                [{ indent: '-1' }, { indent: '+1' }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
                [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
                [{ script: 'sub' }, { script: 'super' }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
                ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
                ['clean'], // 清除文本格式-----['clean']
                ['image'] // 链接、图片、视频-----['link', 'image', 'video']
            ];
            this.editorOption = quillRedefine({
                // 图片上传的设置
                uploadConfig: {
                    action: "/api/admin/upload",  // 必填参数 图片上传地址
                    res: (respnse) => {
                        return respnse.data.message.startsWith('http') ? respnse.data.message : '/api'+respnse.data.message;//return图片url
                    },
                    name: 'file'  // 图片上传参数名
                },
                toolOptions: toolbarOptions,
            })
        },
        onSubmitRelationCategory() {
            this.productForm.relationCategoryIds = [];
            for(var i=0; i<this.relationCategoryIds.length; i++) {
                if(this.relationCategoryIds[i].length>0) {
                    this.productForm.relationCategoryIds.push(this.relationCategoryIds[i]);
                }
            }
            this.relationCategoryDialogVisible = false;
        },
        deliveryFormatter(row, column, cellValue) {
            return cellValue ? cellValue + "天" : "未定";
        },
        addInfo() {
            this.infos.push({
                key: this.getUuid(),
                name: '',
                value: '',
            });
        },
        delInfo(key) {
            this.infos = this.infos.filter(it => it['key'] !== key);
        }
    },
    created() {
        this.init();
        this.initQuill();
    },
}
</script>
<style>
.groupInput .el-input-group__prepend {
    padding: 0;
    border: 0;
}
.groupInput .el-input-group__prepend input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    border-right: 1px solid #fff;
}
.groupInput .el-input-group__prepend input:focus {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: 1px solid #66b1ff;
}
.el-icon-question:before {
    color: #999;
}
</style>